var ko = require('knockout');
require('knockout-postbox');

function Loader(params) {
  if (params.isLoading === undefined) {
    this.isLoading = false;
  } else {
    this.isLoading = params.isLoading;
  }
  this.isLoading = ko.observable().subscribeTo('loadingIndicator');
}

Loader.prototype.triggerLoading = function() {
  this.isLoading(!this.isLoading());
};

module.exports = Loader;
